export enum PaymentState {
	NotStarted = 'NOT_STARTED',
	Initializing = 'INITIALIZING',
	Processing = 'PROCESSING',
	Cancelling = 'CANCELLING'
}

/**
 * Derives the high-level payment UI state from the individual flow flags.
 * Order matters: cancelling wins, then not-started, then initializing.
 */
export const computePaymentState = (opts: {
	isCancelling: boolean
	paymentStarted: boolean
	isInitiating: boolean
	isWaitingForProviderData: boolean
}): PaymentState => {
	if (opts.isCancelling) {
		return PaymentState.Cancelling
	}
	if (!opts.paymentStarted) {
		return PaymentState.NotStarted
	}
	// Either initiation is under way, or we have initiated and are waiting for the
	// provider data (e.g. Adyen/Verifone) to be ready.
	if (opts.isInitiating || opts.isWaitingForProviderData) {
		return PaymentState.Initializing
	}
	return PaymentState.Processing
}

/** A payment initiation is abandoned if the backend never registers it in time. */
export const INITIATION_TIMEOUT_MS = 15 * 1000

/**
 * Whether a pending initiation has exceeded the timeout window and should be
 * cleared. Returns false when no initiation attempt timestamp is set.
 */
export const isInitiationTimedOut = (initiationAttemptedAt: number | undefined | null, now: number): boolean =>
	!!initiationAttemptedAt && initiationAttemptedAt < now - INITIATION_TIMEOUT_MS
